import { Moon, Sun } from 'lucide-react'
import { useThemeStore } from '../stores/useThemeStore'

interface ThemeToggleProps {
  className?: string
}

/** Light/dark toggle. Persists to localStorage and flips the `dark` class on <html>. */
export const ThemeToggle = ({ className = '' }: ThemeToggleProps) => {
  const theme = useThemeStore((s) => s.theme)
  const toggleTheme = useThemeStore((s) => s.toggleTheme)
  const isDark = theme === 'dark'

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={`p-2 rounded-full text-foreground hover:bg-muted transition-colors ${className}`}
    >
      {isDark ? <Sun size={20} /> : <Moon size={20} />}
    </button>
  )
}
